<template>
  <div>
    <el-form :model="myForm" ref="editKaJunRef" :rules="rules" label-width="100px" size="small">
      <el-form-item label="关联奖品" prop="name">
        {{ name }}
      </el-form-item>
      <el-form-item label="卡号" prop="cardKey">
        <el-input v-model="myForm.cardKey" placeholder="请输入卡号"></el-input>
      </el-form-item>
      <el-form-item label="卡密" prop="cardCode">
        <el-input v-model="myForm.cardCode" placeholder="请输入卡密"></el-input>
      </el-form-item>

      <el-form-item>
        <div class="btnDiv">
          <el-button @click="quXiaoClick">取 消</el-button>
          <el-button type="primary" @click="diaQueDingClick">确 定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
/* eslint-disable */
import uploadImg from '@/components/common/uploadImg/Index.vue'
import { makeForm } from '@/utils/tools.js'
export default {
  props: ['rowData', 'name', 'prizeId', 'tenantName'],
  components: { uploadImg },
  data() {
    return {
      myForm: {
        cardCode: '',
        cardKey: '',
        id: '',
      },
      rules: {
        cardKey: [{ required: true, message: '请输入卡号', trigger: 'blur' }],
        cardCode: [{ required: true, message: '请输入卡密', trigger: 'blur' }],
      },
    }
  },
  created() {},
  mounted() {
    if (this.rowData) {
      makeForm(this.myForm, this.rowData)
    }
    console.log('this.myForm', this.myForm)
  },
  methods: {
    imgChage(item) {
      this.myForm[item.name] = item.url
    },
    // 确定
    async diaQueDingClick() {
      this.$refs.editKaJunRef.validate(async (valid) => {
        if (valid) {
          let canshu = {
            ...this.myForm,
            prizeId: this.prizeId,
            tenantName: this.tenantName,
          }
          // 编辑
          if (this.rowData) {
            const res = await this.$API.card.update(canshu)
            if (res.status != 200) return this.$message.error(res.msg)
          } else {
            const res = await this.$API.card.add(canshu)
            if (res.status != 200) return this.$message.error(res.msg)
          }
          this.$emit('diaQueDingClick')
        }
      })
    },
    // 取消
    quXiaoClick() {
      this.$emit('quXiaoClick')
    },
  },
  destroyed() {},
}
</script>
<style lang="scss" scoped>
.el-input {
  width: 200px;
}
.btnDiv {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
